import {
  AUTH_CONTEXT_KEYS,
  useAuthContext,
} from '@r-and-a-shared-ui/auth-client';
import { usePlayerPortalsConfigContext } from '@r-and-a-shared-ui/common-ui';
import { getAllUserRolesFromChampionship } from '@r-and-a-shared-ui/common-ui';
import React, { useMemo } from 'react';

type RolesRestriction = {
  required?: string[];
};

export type PlayerPortalRestrictedContentProps = {
  children: React.ReactNode;
  accessRestrictions?: {
    componentRoles?: RolesRestriction;
  };
};

export const PlayerPortalRestrictedContent = (
  props: PlayerPortalRestrictedContentProps,
) => {
  const { children, accessRestrictions } = props;
  const { componentRoles } = accessRestrictions ?? {};

  const { userState } = useAuthContext(AUTH_CONTEXT_KEYS.PP_CONTEXT_KEY);
  const configContext = usePlayerPortalsConfigContext();
  const { currentChampionship } = configContext || {};

  const userRoles: string[] | null = getAllUserRolesFromChampionship(
    userState,
    currentChampionship,
  );

  const requiredRoles = useMemo(
    () => (componentRoles?.required ?? []).map(r => r.toLowerCase()),
    [componentRoles?.required],
  );

  const hasRoleRestrictions = requiredRoles.length > 0;

  if (!hasRoleRestrictions) {
    return <>{children}</>;
  }

  if (!userRoles) {
    return null;
  }

  const hasRequiredRoles = requiredRoles.some(r =>
    userRoles.some(u => u.toLowerCase() === r.toLowerCase()),
  );

  if (!hasRequiredRoles) {
    return null;
  }

  return <>{children}</>;
};
